import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import Page from "components/Page/Page";
import Card from "components/Card/Card";
import PortfolioLayout from "components/PortfolioLayout/PortfolioLayout";
import projects from "data/projects.json";

const ProjectPane = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;

const SectionHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 0.5rem;
  flex-wrap: wrap;
  gap: 1rem;
`;

const SectionHeader = styled.h2`
  font-family: "IBM Plex Sans", sans-serif;
  font-size: 1.5rem;
  font-weight: 400;
  letter-spacing: -0.02rem;
  margin-top: 0;
  margin-bottom: 0.5rem;
  line-height: 1.25;
  color: var(--text-primary);
`;

const SectionIntro = styled.p`
  font-size: 1.125rem;
  line-height: 1.65;
  margin-top: 0.5rem;
  margin-bottom: 2rem;
  color: var(--text-primary);
`;

const SectionDivider = styled.hr`
  border: none;
  border-top: 1px solid var(--divider-color);
  margin: 2.5rem 0;
  
  &:first-child {
    margin-top: 0;
  }
`;

const ProjectListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-bottom: 1px solid var(--border-color);
`;

function ProjectCards({ sectionProjects }) {
  const cards = sectionProjects.map((p, i) => (
    <NavLink 
      key={p.slug} 
      to={`/${p.slug}`}
      style={{ textDecoration: "none", borderBottom: "none" }}
    >
      <Card 
        title={p.title} 
        tag={p.company ?? ""} 
        tags={p.tags ?? []}
        date={p.date}
        img={p.cover}
        viewMode="list"
        style={{ animationDelay: `${i * 0.08}s` }}
      >
        {p.description}
      </Card>
    </NavLink>
  ));

  return <ProjectListContainer>{cards}</ProjectListContainer>;
}

export default function Home2026() {
  return (
    <Page currentPage="home">
      <PortfolioLayout>
        <ProjectPane>
          {SECTIONS.map((section, i) => {
            const sectionProjects = projects.filter(
              (p) => p.section === section.key
            );
            if (sectionProjects.length === 0) return null;

            return (
              <React.Fragment key={section.key}>
                {i > 0 && <SectionDivider />}
                <SectionHeaderRow>
                  <SectionHeader>{section.heading}</SectionHeader>
                </SectionHeaderRow>
                <SectionIntro>{section.intro}</SectionIntro>
                
                <ProjectCards 
                  sectionProjects={sectionProjects} 
                />
              </React.Fragment>
            );
          })}
        </ProjectPane>
      </PortfolioLayout>
    </Page>
  );
}

const SECTIONS = [
  {
    key: "ai-product-lead",
    heading: "AI Product Lead — Sopra Steria",
    intro:
      "As AI Product Lead at Sopra Steria, I lead the development of an integrated suite of governed AI workflows for 3000+ consultants and everyone working on sales and bids to automate CV quality, talent matching, improve the bid process, turning tacit expert judgment and business critical manual processes into enterprise AI software.",
  },
  {
    key: "founder-builder",
    heading: "AI founder and builder",
    intro:
      "Beyond my product work at Sopra Steria, I build independently. SitesAI is an AI-first product for retail market research and expansion, designed and built solo.",
  },
  {
    key: "pm-design",
    heading: "Product Manager and Design Director",
    intro:
      "Fifteen years across startups and large enterprises in California and Norway, taking enterprise B2B SaaS solutions from idea to launch and beyond — across location intelligence, healthcare analytics, and digital asset management.",
  },
];
